import { render } from "./PresuFacturas.vue?vue&type=template&id=2668ad3f&scoped=true"
import script from "./PresuFacturas.vue?vue&type=script&lang=js"
export * from "./PresuFacturas.vue?vue&type=script&lang=js"

import "./PresuFacturas.vue?vue&type=style&index=0&id=2668ad3f&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2668ad3f"

export default script